export const convertToEnglishDigits = (value: string): string => {
  if (!value) return '';

  value = value.replace(/[۰-۹]/g, (d) =>
    String.fromCharCode(d.charCodeAt(0) - 1728),
  );

  value = value.replace(/[٠-٩]/g, (d) =>
    String.fromCharCode(d.charCodeAt(0) - 1584),
  );

  return value;
};
